<template>
  <div class="partner-resumes-base-interaction">
    <div v-if="pending && !receivedData"
         style="min-height: 20rem; position: relative">
      <BasePreloader/>
    </div>
    <ErrorView v-if="error"
               :code="error.code"
               :title="error.message"/>

    <template v-else-if="receivedData">
      <div class="partner-resumes-base-interaction__table">
        <APResumesBaseInteractionsPageHeadRow :is-empty="isEmpty"/>

        <div class="partner-resumes-base-interaction__table-content">
          <div v-if="isEmpty" class="partner-resumes-base-interaction__empty">
            <picture class="partner-resumes-base-interaction__empty-bg">
              <!--              <source srcset="@/assets/img/empty-resume-base.svg" media="(max-width: 550px)">-->
              <img src="@/assets/img/empty-resume-base.svg" alt="bg">
            </picture>
            <h3 class="partner-resumes-base-interaction__empty-title">{{
                $tResumesBaseInteraction('No resumes on interaction')
              }}</h3>
          </div>

          <template v-else>
            <template v-for="item in receivedData.data">
              <APResumesBaseInteractionsPageRow :key="item.id"
                                                :resume="item"/>
            </template>
          </template>

          <BasePreloader v-if="pending"/>
        </div>
      </div>

      <div v-if="receivedData.last_page > 1"
           class="partner-resumes-base-interaction__footer">
        <Pagination :quantity="receivedData.last_page"
                    :withGoTo="false"
                    class="partner-resumes-base-interaction__pagination"/>
      </div>
    </template>
  </div>
</template>

<script>
  import ErrorView from '@/components/ErrorView'
  import Pagination from '@/components/Pagination'

  import APResumesBaseInteractionsPageHeadRow
    from '@/components/partnerResumeBaseInteractions/APResumesBaseInteractionsPageHeadRow'
  import APResumesBaseInteractionsPageRow
    from '@/components/partnerResumeBaseInteractions/APResumesBaseInteractionsPageRow'
  import {http} from "@/axios"
  import {CancelToken, isCancel} from "axios"
  import handleError from "@/helpers/handleError"
  import {mapGetters} from 'vuex'

  const filterConstants = {
    FILTER_KEY_CANDIDATE: 'f-candidate',
    FILTER_KEY_STEP: 'f-step',
    PAGE: 'page',
  }

  const interactionSteps = [
    {
      id: 1,
      ico: 'ico-passport',
      key: 'passport',
    },
    {
      id: 2,
      ico: 'ico-umbrella',
      key: 'insurance',
    },
    {
      id: 3,
      ico: 'ico-visa',
      key: 'visa',
    },
    {
      id: 4,
      ico: 'ico-visa',
      key: 'invite',
    },
    {
      id: 5,
      ico: 'ico-ticket',
      key: 'tickets',
    },
    {
      id: 6,
      ico: 'ico-contract',
      key: 'documents',
    }
  ]

  export default {
    name: 'AccountPartnerResumesBaseOnInteractionsPage',
    components: {
      ErrorView,
      Pagination,
      APResumesBaseInteractionsPageRow,
      APResumesBaseInteractionsPageHeadRow
    },
    provide: {
      ...filterConstants,

      interactionSteps
    },
    data() {
      return {
        pending: null,
        receivedData: {
          items: [1, 2, 3, 4, 5]
        },
        error: null,
        pagesQuantity: null,

        ...filterConstants
      }
    },
    computed: {
      ...mapGetters('user', [
        'isModerator'
      ]),
      isEmpty() {
        return !this.pending && !this.$get(this.receivedData, 'data', []).length
      }
    },
    methods: {
      load() {
        if (this.cancel) {
          this.cancel()
          this.cancel = null
        }

        this.pending = true
        this.error = null

        const query = this.$route.query
        const params = {}

        for (const key in filterConstants) {
          const paramKey = filterConstants[key]

          params[paramKey] = query[paramKey]
        }

        const link = this.isModerator
          ? '/api/backoffice/resume-on-interaction'
          : '/api/cabinet/agent/resume-on-interaction'

        http.get(link, {
          params,
          cancelToken: new CancelToken((c) => {
            this.cancel = c;
          })
        })
          .then(({data}) => {
            this.receivedData = data.data
            this.pending = false
          })
          .catch(e => {
            if (isCancel(e)) {
              return
            }

            this.receivedData = null

            this.error = {
              code: e.response && e.response.status,
              message: handleError(e)
            }

            this.pending = false
          })
      }
    },
    created() {
      this.load()

      createMapRouteQueryWatchers(
        this,
        Object.values(filterConstants),
        () => {
          this.load()
        }
      )
    }
  }

  function createMapRouteQueryWatchers(vm, keys, callBack) {
    keys.forEach(key => {
      vm.$watch(
        function () {
          return vm.$route.query[key]
        },
        callBack
      )
    })
  }
</script>

<style lang="less">

</style>
